import { useState } from "react";
import { AdminModules } from "../features";
import { gql, useMutation } from "@apollo/client";
import { useApolloQuery } from "../../../../hooks";
import { useAuthSession } from "../../../../components/AuthSessionProvider";
import { useNotify } from "../../../../components/@common/NotificationsProvider";
import { useNavigate } from "react-router-dom";
import {
  ConfirmationDeleteModal,
  useLanguageTranslator,
} from "../../../../components";
import dayjs from "dayjs";

const GET_INDICATORS_CATEGORIES_WITH_PAGINATION = gql`
  query GetIndicatorsCategoriesWithPagination($page: Int!) {
    indicatorCategoriesWithPagination(page: $page) {
      collection {
        createdAt
        id
        name
        updatedAt
      }
      metadata {
        currentPage
        limitValue
        totalCount
        totalPages
      }
    }
  }
`;

const DELETE_INDICATORS_CATEGORY = gql`
  mutation IndicatorCategoryDelete($id: ID!) {
    indicatorCategoryDelete(input: { id: $id }) {
      clientMutationId
      indicatorCategory {
        createdAt
        id
        name
        updatedAt
      }
    }
  }
`;

function IndicatorsCategories() {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isOpenDelete, setIsOpenDelete] = useState({ status: false, data: {} });

  const { user } = useAuthSession() as any;
  const notify = useNotify();
  const navigate = useNavigate();
  const { translator } = useLanguageTranslator();

  const {
    data: indicatorsCategoriesList,
    loading,
    refetch,
  } = useApolloQuery({
    queryDocument: GET_INDICATORS_CATEGORIES_WITH_PAGINATION,
    isPrivateCall: true,
    variables: {
      page: page,
    },
  });

  const [deleteIndicatorsCategory, { loading: deleteLoading, error }] =
    useMutation(DELETE_INDICATORS_CATEGORY, {
      context: {
        headers: {
          "access-token": user?.accessToken,
          client: user?.client,
          uid: user?.email,
        },
      },
    });

  const modifiedGetIndicatorsCategories =
    indicatorsCategoriesList?.indicatorCategoriesWithPagination?.collection?.map(
      (item: any) => {
        return {
          sr: item?.id,
          id: item?.id,
          name: item?.name,
          createdAt: dayjs(item?.createdAt?.split("T")?.[0] || "").format(
            "DD.MM.YYYY"
          ),
          updatedAt: dayjs(item?.updatedAt?.split("T")?.[0] || "").format(
            "DD.MM.YYYY"
          ),
        };
      }
    );

  async function onClickHandler(type: string, clickedId: any) {
    if (type === "edit") {
      navigate(`/admin/indicators-categories/update?id=${clickedId}`);
      return;
    }
    if (type === "delete") {
      setIsOpenDelete({ status: true, data: { id: clickedId } });
    }
  }

  async function onClickDeleteHandler(item: any) {
    const response = await deleteIndicatorsCategory({
      variables: { id: Number(item?.id) },
    });
    if (response?.data) {
      notify.success(`Indicators Category Delete successfuly!`);
      setIsOpenDelete({ status: false, data: {} });
      setTimeout(async () => {
        await refetch();
      }, 1000);
    }
  }

  function handleDeleteClose() {
    setIsOpenDelete({ status: false, data: {} });
  }

  return (
    <>
      <ConfirmationDeleteModal
        isOpen={isOpenDelete?.status}
        item={isOpenDelete?.data}
        onClickHandler={onClickDeleteHandler}
        handleClose={handleDeleteClose}
      />
      <AdminModules
        title={translator("Indicators Categories")}
        path="/admin/indicators-categories/add-new"
        data={modifiedGetIndicatorsCategories || []}
        moduleKey="indicators-categories-module"
        page={page}
        metadata={
          indicatorsCategoriesList?.indicatorCategoriesWithPagination?.metadata || {}
        }
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        setPage={setPage}
        onClickHandler={onClickHandler}
      />
    </>
  );
}

export { IndicatorsCategories };
